import React from 'react';
import { Card, CardMedia } from '@mui/material';

const AboutSection = () => {
  return (
    <section className="bg-slate-900 text-white py-16  ">
      <div className="container mx-auto flex flex-col md:flex-row md:my-20 items-center px-4 md:px-12">
      <div className="md:w-1/3 flex justify-center md:justify-end md:mx-10">
          <Card className="shadow-lg sm:w-40 md:w-[500px] md:h-[215px]">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/oQj4pLOHiLg?si=L9Ga4sSJrO8Q7IFR" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </Card>
        </div>
        <div className="md:w-2/3 mb-8 md:mb-0 sm:my-10 md:my-auto">
          <h2 className="text-4xl font-bold mb-4  ">About <span className='text-yellow-300'>ROZGAAR</span></h2>
          <p className="text-lg leading-relaxed">
          Rozgaar is more than just an e-commerce platform – it’s a bridge between talented local artisans like Sunita and consumers like Anjali who value authenticity and quality. With Rozgaar, Sunita can easily create a storefront, list her products, and showcase her craftsmanship. She doesn’t have to worry about complex logistics or tech barriers – the platform is simple, intuitive, and built for local sellers.
          </p>
        </div>
        
      </div>
    </section>
  );
};

export default AboutSection;
